import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var PairsPipe = (function () {
    function PairsPipe() {
    }
    PairsPipe.prototype.transform = function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).map(function (k) { return [k, obj[k]]; });
    };
    return PairsPipe;
}());
export { PairsPipe };
PairsPipe.decorators = [
    { type: Pipe, args: [{ name: 'pairs' },] },
];
/** @nocollapse */
PairsPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=pairs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/pairs.js
// module id = 252
// module chunks = 4